<div class="flex items-center gap-1">
  <a
    [routerLink]="dashboardLink"
    routerLinkActive="bg-primary/10"
    [routerLinkActiveOptions]="{ exact: true }"
    class="flex min-w-0 flex-1 items-center gap-3 rounded-xl p-3 text-left transition-colors hover:bg-base-300"
    (click)="onLinkClick()"
  >
    <div class="avatar shrink-0" [class.avatar-placeholder]="!avatarUrl() || avatarFailed()">
      <div
        class="flex h-11 w-11 items-center justify-center rounded-full text-sm font-semibold"
        [class]="!avatarUrl() || avatarFailed() ? avatarColor() : ''"
      >
        @if (avatarUrl() && !avatarFailed()) {
          <img [src]="avatarUrl()" [alt]="user().nickname" (error)="onAvatarError()" />
        } @else {
          {{ initials() }}
        }
      </div>
    </div>
    <div class="min-w-0 flex-1">
      <span class="block truncate font-semibold">{{ user().nickname }}</span>
      <span class="block truncate text-sm text-base-content/70">{{ user().email }}</span>
    </div>
  </a>

  <a
    [routerLink]="profileLink"
    routerLinkActive="bg-primary/10"
    [routerLinkActiveOptions]="{ exact: false }"
    class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl transition-colors hover:bg-base-300"
    aria-label="Настройки профиля"
    title="Настройки профиля"
    (click)="onSettingsClick()"
  >
    <lucide-icon name="settings" class="h-5 w-5 stroke-current text-base-content/70" />
  </a>
</div>
